export function getErrorMessage(error: any): string {
    if (!error) return '';

    if (error.message) return error.message;

    if (typeof error === 'object') {
        for (const key in error) {
            const nested = error[key];
            const msg = getErrorMessage(nested);
            if (msg) return msg;
        }
    }

    return '';
}
